import {
  IAddress,
  ICommitteeMemberInput,
  ICooperativeDetails,
  IDeclaration,
  IDocumentsInput,
  IExecutiveMemberInput,
  IFinancialAuditInput,
  IFinancialIncome,
  IFinancialLoan,
  IFinancialShare,
  IFinancialTax,
  IShareMemberInput,
} from "../../exports/interfaces";

const toNumberOrNull = (value: unknown) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getRegisterFormInitialState = (
  initialData?: ICooperativeDetails | null,
) => {
  const responseData = initialData as any;

  return {
  cooperativeInfo: {
    registrationNumber: initialData?.registrationNumber ?? "",
    businessregistrationNumber: initialData?.businessregistrationNumber ?? "",
    nameNepali: initialData?.nameNepali ?? "",
    nameEnglish: initialData?.nameEnglish ?? "",
    natureOfWork: initialData?.natureOfWork ?? "",
    workingArea: initialData?.workingArea ?? "",
    panNumber: initialData?.panNumber ?? "",
    email: initialData?.email ?? "",
    mobileNumber: initialData?.mobileNumber ?? "",
    contactPerson: initialData?.contactPerson ?? "",
    registeredDate: initialData?.registeredDate ?? "",
    registeredEnglishDate: initialData?.registeredEnglishDate ?? "",
    registeredAt: initialData?.registeredAt ?? "",
    registeredOfficeAddress: initialData?.registeredOfficeAddress ?? "",
    isRegisteredInFederation: initialData?.isRegisteredInFederation ?? null,
    staffCount: initialData?.staffCount ?? null,
    softwareUsed: initialData?.softwareUsed ?? "",
    maleMembers: initialData?.maleMembers ?? null,
    femaleMembers: initialData?.femaleMembers ?? null,
    otherMembers: initialData?.otherMembers ?? null,
  } as ICooperativeDetails,
  address: {
    province: initialData?.address?.province ?? "",
    district: initialData?.address?.district ?? "",
    municipality: initialData?.address?.municipality ?? "",
    streetTole: initialData?.address?.streetTole ?? "",
    ward: initialData?.address?.ward ?? null,
  } as IAddress,
  shareFinancial: {
    fiscalYear: responseData?.financial?.share?.fiscalYear ?? "",
    maleMembers: toNumberOrNull(responseData?.financial?.share?.maleMembers),
    femaleMembers: toNumberOrNull(responseData?.financial?.share?.femaleMembers),
    otherMembers: toNumberOrNull(responseData?.financial?.share?.otherMembers),
    institutionalMembers: toNumberOrNull(responseData?.financial?.share?.institutionalMembers),
    totalShareMembers: toNumberOrNull(responseData?.financial?.share?.totalShareMembers),
    totalGeneralSaving: responseData?.financial?.share?.totalGeneralSaving ?? "",
    totalRegularSaving: responseData?.financial?.share?.totalRegularSaving ?? "",
    totalPeriodicSaving: responseData?.financial?.share?.totalPeriodicSaving ?? "",
    totalSavingAmount: responseData?.financial?.share?.totalSavingAmount ?? "",
    femaleDepositors: responseData?.financial?.share?.femaleDepositors ?? "",
    maleDepositors: responseData?.financial?.share?.maleDepositors ?? "",
    otherDepositors: responseData?.financial?.share?.otherDepositors ?? "",
    totalDepositors: responseData?.financial?.share?.totalDepositors ?? "",
    balanceSheet: responseData?.financial?.share?.balanceSheet ?? "",
    totalLiabilities: responseData?.financial?.share?.totalLiabilities ?? "",
    totalAssets: responseData?.financial?.share?.totalAssets ?? "",
    totalLiquidAssets: responseData?.financial?.share?.totalLiquidAssets ?? "",
    tlaToTaRatio: responseData?.financial?.share?.tlaToTaRatio ?? "",
    cash: responseData?.financial?.share?.cash ?? "",
    association: responseData?.financial?.share?.association ?? "",
    districtUnion: responseData?.financial?.share?.districtUnion ?? "",
    bank: responseData?.financial?.share?.bank ?? "",
  } as IFinancialShare,
  loanFinancial: {
    fiscalYear: responseData?.financial?.loan?.fiscalYear ?? "",
    totalShareCapital: responseData?.financial?.loan?.totalShareCapital ?? "",
    totalReserveFund: responseData?.financial?.loan?.totalReserveFund ?? "",
    deficitReplenishmentFund: responseData?.financial?.loan?.deficitReplenishmentFund ?? "",
    accumulatedProfitLoss: responseData?.financial?.loan?.accumulatedProfitLoss ?? "",
    coreCapital: responseData?.financial?.loan?.coreCapital ?? "",
    totalPassLoan: responseData?.financial?.loan?.totalPassLoan ?? "",
    totalSubStandardLoan: responseData?.financial?.loan?.totalSubStandardLoan ?? "",
    totalDoubtfulLoan: responseData?.financial?.loan?.totalDoubtfulLoan ?? "",
    totalLossLoan: responseData?.financial?.loan?.totalLossLoan ?? "",
    totalLoanDisbursed: responseData?.financial?.loan?.totalLoanDisbursed ?? "",
    externalLoan: responseData?.financial?.loan?.externalLoan ?? "",
    maleBorrowers: responseData?.financial?.loan?.maleBorrowers ?? "",
    femaleBorrowers: responseData?.financial?.loan?.femaleBorrowers ?? "",
    othersBorrowers: responseData?.financial?.loan?.othersBorrowers ?? "",
    totalBorrowers: responseData?.financial?.loan?.totalBorrowers ?? "",
    llpPassLoan: responseData?.financial?.loan?.llpPassLoan ?? "",
    llpSubStandardLoan: responseData?.financial?.loan?.llpSubStandardLoan ?? "",
    llpDoubtfulLoan: responseData?.financial?.loan?.llpDoubtfulLoan ?? "",
    llpLossLoan: responseData?.financial?.loan?.llpLossLoan ?? "",
    totalLoanLossProvision: responseData?.financial?.loan?.totalLoanLossProvision ?? "",
    additionalProvisionLoanLoss: responseData?.financial?.loan?.additionalProvisionLoanLoss ?? "",
    assetsRevaluationReserve: responseData?.financial?.loan?.assetsRevaluationReserve ?? "",
    freeReserve: responseData?.financial?.loan?.freeReserve ?? "",
    supplementaryCapital: responseData?.financial?.loan?.supplementaryCapital ?? "",
    totalCapitalFund: responseData?.financial?.loan?.totalCapitalFund ?? "",
    totalNonPerformingLoan: responseData?.financial?.loan?.totalNonPerformingLoan ?? "",
    nplPercentage: responseData?.financial?.loan?.nplPercentage ?? "",
    totalRiskWeightedAssets: responseData?.financial?.loan?.totalRiskWeightedAssets ?? "",
    coreCapitalRatio: responseData?.financial?.loan?.coreCapitalRatio ?? "",
    totalCapitalFundRatio: responseData?.financial?.loan?.totalCapitalFundRatio ?? "",
    totalBorrowing: responseData?.financial?.loan?.totalBorrowing ?? "",
    loanRescheduledCount: toNumberOrNull(responseData?.financial?.loan?.loanRescheduledCount),
    loanRescheduledAmount: responseData?.financial?.loan?.loanRescheduledAmount ?? "",
    investmentPrivateLtd: responseData?.financial?.loan?.investmentPrivateLtd ?? "",
    investmentHouseBuilding: responseData?.financial?.loan?.investmentHouseBuilding ?? "",
  } as IFinancialLoan,
  incomeFinancial: {
    fiscalYear: responseData?.financial?.income?.fiscalYear ?? "",
    operationalIncome: responseData?.financial?.income?.operationalIncome ?? "",
    otherIncome: responseData?.financial?.income?.otherIncome ?? "",
    operationalExpenses: responseData?.financial?.income?.operationalExpenses ?? "",
    otherExpenses: responseData?.financial?.income?.otherExpenses ?? "",
    netProfitLoss: responseData?.financial?.income?.netProfitLoss ?? "",
  } as IFinancialIncome,
  auditFinancial: {
    fiscalYear: responseData?.financial?.audit?.fiscalYear ?? "",
    auditorName: responseData?.financial?.audit?.auditorName ?? "",
    auditorMobile: responseData?.financial?.audit?.auditorMobile ?? "",
    auditorAddress: responseData?.financial?.audit?.auditorAddress ?? "",
    icanNumber: responseData?.financial?.audit?.icanNumber ?? "",
    agmDate: responseData?.financial?.audit?.agmDate ?? "",
    participants: toNumberOrNull(responseData?.financial?.audit?.participants),
    participantsPercent: responseData?.financial?.audit?.participantsPercent ?? "",
    file: null,
    fileName: "",
    documentUrl: responseData?.financial?.audit?.documentUrl ?? "",
  } as IFinancialAuditInput,
  taxFinancial: {
    fiscalYear: responseData?.financial?.tax?.fiscalYear ?? "",
    incomeTax: responseData?.financial?.tax?.incomeTax ?? "",
    interestTax: responseData?.financial?.tax?.interestTax ?? "",
    employeeTax: responseData?.financial?.tax?.employeeTax ?? "",
    taxOthers: responseData?.financial?.tax?.taxOthers ?? "",
    serviceTax: responseData?.financial?.tax?.serviceTax ?? "",
    rentalTax: responseData?.financial?.tax?.rentalTax ?? "",
    localOthers: responseData?.financial?.tax?.localOthers ?? "",
  } as IFinancialTax,
  committeeCooperative: {
    committeeType: responseData?.cooperativeandexecutive?.committeemember?.committeeType ?? "",
    position: responseData?.cooperativeandexecutive?.committeemember?.position ?? "",
    positionStatus: responseData?.cooperativeandexecutive?.committeemember?.positionStatus ?? "",
    grandmotherName: responseData?.cooperativeandexecutive?.committeemember?.grandmotherName ?? "",
    fatherName: responseData?.cooperativeandexecutive?.committeemember?.fatherName ?? "",
    husbandName: responseData?.cooperativeandexecutive?.committeemember?.husbandName ?? "",
    fullName: responseData?.cooperativeandexecutive?.committeemember?.fullName ?? "",
    email: responseData?.cooperativeandexecutive?.committeemember?.email ?? "",
    citizenship: responseData?.cooperativeandexecutive?.committeemember?.citizenship ?? "",
    pan: responseData?.cooperativeandexecutive?.committeemember?.pan ?? "",
    nid: responseData?.cooperativeandexecutive?.committeemember?.nid ?? "",
    issuedDistrict: responseData?.cooperativeandexecutive?.committeemember?.issuedDistrict ?? "",
    tenureStart: responseData?.cooperativeandexecutive?.committeemember?.tenureStart ?? "",
    tenureEnd: responseData?.cooperativeandexecutive?.committeemember?.tenureEnd ?? "",
    province: responseData?.cooperativeandexecutive?.committeemember?.province ?? "",
    district: responseData?.cooperativeandexecutive?.committeemember?.district ?? "",
    municipality: responseData?.cooperativeandexecutive?.committeemember?.municipality ?? "",
    ward: toNumberOrNull(responseData?.cooperativeandexecutive?.committeemember?.ward),
    street: responseData?.cooperativeandexecutive?.committeemember?.street ?? "",
    education: responseData?.cooperativeandexecutive?.committeemember?.education ?? "",
    file: null,
    fileName: "",
    documentUrl: responseData?.cooperativeandexecutive?.committeemember?.photoUrl ?? "",
    bodFile: null,
    bodFileName: "",
    bodDocumentUrl: responseData?.cooperativeandexecutive?.committeemember?.bodDocumentUrl ?? "",
  } as ICommitteeMemberInput,
  executiveCooperative: {
    position: responseData?.cooperativeandexecutive?.executivemember?.position ?? "",
    positionStatus: responseData?.cooperativeandexecutive?.executivemember?.positionStatus ?? "",
    grandmotherName: responseData?.cooperativeandexecutive?.executivemember?.grandmotherName ?? "",
    fatherName: responseData?.cooperativeandexecutive?.executivemember?.fatherName ?? "",
    husbandName: responseData?.cooperativeandexecutive?.executivemember?.husbandName ?? "",
    fullName: responseData?.cooperativeandexecutive?.executivemember?.fullName ?? "",
    gender: responseData?.cooperativeandexecutive?.executivemember?.gender ?? "",
    mobile: responseData?.cooperativeandexecutive?.executivemember?.mobile ?? "",
    email: responseData?.cooperativeandexecutive?.executivemember?.email ?? "",
    address: responseData?.cooperativeandexecutive?.executivemember?.address ?? "",
    pan: responseData?.cooperativeandexecutive?.executivemember?.pan ?? "",
    nid: responseData?.cooperativeandexecutive?.executivemember?.nid ?? "",
    citizenship: responseData?.cooperativeandexecutive?.executivemember?.citizenship ?? "",
    issuedDistrict: responseData?.cooperativeandexecutive?.executivemember?.issuedDistrict ?? "",
    province: responseData?.cooperativeandexecutive?.executivemember?.province ?? "",
    district: responseData?.cooperativeandexecutive?.executivemember?.district ?? "",
    municipality: responseData?.cooperativeandexecutive?.executivemember?.municipality ?? "",
    ward: toNumberOrNull(responseData?.cooperativeandexecutive?.executivemember?.ward),
    street: responseData?.cooperativeandexecutive?.executivemember?.street ?? "",
    experience: toNumberOrNull(responseData?.cooperativeandexecutive?.executivemember?.experience),
    currentPositionDuration: toNumberOrNull(responseData?.cooperativeandexecutive?.executivemember?.currentPositionDuration),
    education: responseData?.cooperativeandexecutive?.executivemember?.education ?? "",
    file: null,
    fileName: "",
    documentUrl: responseData?.cooperativeandexecutive?.executivemember?.photoUrl ?? "",
  } as IExecutiveMemberInput,
  shareMember: {
    shareMemberFile: null,
    shareMemberFileName: "",
    shareMemberDocumentUrl: responseData?.shareMember?.shareMemberUrl ?? "",
    shareMaleMembers: responseData?.shareMember?.shareMaleMembers ?? "",
    shareFemaleMembers: responseData?.shareMember?.shareFemaleMembers ?? "",
    shareOthersMembers: responseData?.shareMember?.shareOthersMembers ?? "",
    shareTotalMembers: responseData?.shareMember?.shareTotalMembers ?? "",
    savingMemberFile: null,
    savingMemberFileName: "",
    savingMemberDocumentUrl: responseData?.shareMember?.savingMemberUrl ?? "",
    savingMaleMembers: responseData?.shareMember?.savingMaleMembers ?? "",
    savingFemaleMembers: responseData?.shareMember?.savingFemaleMembers ?? "",
    savingOthersMembers: responseData?.shareMember?.savingOthersMembers ?? "",
    savingTotalMembers: responseData?.shareMember?.savingTotalMembers ?? "",
    loanMemberFile: null,
    loanMemberFileName: "",
    loanMemberDocumentUrl: responseData?.shareMember?.loanMemberUrl ?? "",
    loanMaleMembers: responseData?.shareMember?.loanMaleMembers ?? "",
    loanFemaleMembers: responseData?.shareMember?.loanFemaleMembers ?? "",
    loanOthersMembers: responseData?.shareMember?.loanOthersMembers ?? "",
    loanTotalMembers: responseData?.shareMember?.loanTotalMembers ?? "",
  } as IShareMemberInput,
  documents: {
    regCertificateFile: null,
    regCertificateFileName: "",
    regCertificateDocumentUrl: responseData?.documents?.regCertificateUrl ?? "",
    lawDocumentFile: null,
    lawDocumentFileName: "",
    lawDocumentDocumentUrl: responseData?.documents?.lawDocumentUrl ?? "",
    foundingDocumentFile: null,
    foundingDocumentFileName: "",
    foundingDocumentDocumentUrl: responseData?.documents?.foundingDocumentUrl ?? "",
    panDocumentFile: null,
    panDocumentFileName: "",
    panDocumentDocumentUrl: responseData?.documents?.panDocumentUrl ?? "",
    businessRegistrationFile: null,
    businessRegistrationFileName: "",
    businessRegistrationDocumentUrl: responseData?.documents?.businessRegistrationUrl ?? "",
    taxClearanceFile: null,
    taxClearanceFileName: "",
    taxClearanceDocumentUrl: responseData?.documents?.taxClearanceUrl ?? "",
    meetingDocumentFile: null,
    meetingDocumentFileName: "",
    meetingDocumentDocumentUrl: responseData?.documents?.meetingDocumentUrl ?? "",
    agmDocumentFile: null,
    agmDocumentFileName: "",
    agmDocumentDocumentUrl: responseData?.documents?.agmDocumentUrl ?? "",
    otherDocumentFile: null,
    otherDocumentFileName: "",
    otherDocumentDocumentUrl: responseData?.documents?.otherDocumentUrl ?? "",
  } as IDocumentsInput,
  declaration: {
    name: responseData?.declaration?.name ?? "",
    position: responseData?.declaration?.position ?? "",
    mobile: responseData?.declaration?.mobile ?? "",
    declaration: Boolean(responseData?.declaration?.declaration),
  } as IDeclaration,
  };
};
